import { InjectionToken } from '@angular/core';

export interface OverlayIntegration {
    isOverlayOpen: () => boolean;
}

export const OVERLAY_INTEGRATION = new InjectionToken<OverlayIntegration>('OVERLAY_INTEGRATION', {
    factory: () => {
        return {
            isOverlayOpen: () => false,
        };
    },
});
